import MuiIcon from 'components/Icons/MuiIcon';
import React from 'react';
import styles from './CertifiedOnceContents.module.scss';

const ITEMS = [
  'The certificate is valid',
  'The certification body was accredited to issue it',
  'The accreditation body is a recognised IAF member and MLA signatory for that standard',
];

function CertifiedOnceContents() {
  return (
    <div className={styles['contents']}>
      {ITEMS.map((item, index) => {
        return (
          <div key={index} className={styles['contents--item']}>
            <div className={styles['contents--item--icon']}>
              <MuiIcon name="check_circle" size="lg" />
            </div>
            <p>{item}</p>
          </div>
        );
      })}
    </div>
  );
}

export default CertifiedOnceContents;
